var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlightReturn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 30,
    viewBox: "0 0 33 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.306641 15.002C0.306641 12.987 1.96644 11.3272 3.98146 11.3272L12.9774 11.3272L17.571 1.03035L17.8772 0.302734L23.7336 0.302734L22.5087 11.3272H24.7675L26.8719 8.18768L27.2174 7.65238L32.4234 7.65238L32.1171 9.10761L30.9302 15.002L32.1171 20.8977L32.4234 22.3517L27.2174 22.3517L26.8719 21.8152L24.7687 18.6769L22.5099 18.6769L23.7349 29.7013H17.8784L17.5722 28.9737L12.9774 18.6769L3.98146 18.6769C1.96644 18.6769 0.306641 17.0171 0.306641 15.002ZM2.75652 15.002C2.75652 15.6953 3.28815 16.227 3.98146 16.227L14.5846 16.227L14.8908 16.9546L19.4843 27.2514H20.9775L19.7526 16.227L26.1076 16.227L26.4506 16.7635L28.5587 19.9018H29.4382L28.5195 15.2311L28.4435 15.002L28.5195 14.7717L29.4382 10.1023L28.5587 10.1023L26.4518 13.2418L26.1088 13.7771L19.7538 13.7771L20.9787 2.75262L19.4855 2.75262L14.892 13.0495L14.5858 13.7771L3.98146 13.7771C3.28815 13.7771 2.75652 14.3087 2.75652 15.002Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlightReturn);
export default __webpack_public_path__ + "static/media/flight-return.e8db8cb768dcf966404e38c650ee7c9d.svg";
export { ForwardRef as ReactComponent };